<template>
  <div class="row cycle-tabs" data-module="cycle-tabs">
    <div class="container">
      <div class="row">
        <div class="col-12 mx-auto">
          <ul class="cycle-tabs-titles">
            <li
              v-for="tab in tabs"
              :class="['cycle-tabs-title', { 'is-active': tab.isActive }]"
              :key="tab.name"
            >
              <button @click="selectTab(tab)" v-if="tab.name.length <= 2">
                {{ tab.name.toUpperCase() }}
              </button>
              <button @click="selectTab(tab)" v-else>
                {{ tab.name.charAt(0).toUpperCase() + tab.name.slice(1) }}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="container mt-6 mt-md-7">
      <div class="row cycle-tabs-content-wrapper">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tabs",
  data() {
    return {
      tabs: []
    };
  },
  created() {
    this.tabs = this.$children;
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = tab.name == selectedTab.name;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.cycle-tabs-titles {
  border-bottom: 2px solid #E0E0E0;
  flex-direction: row;

  .cycle-tabs-title {
    border: 0;
    position: relative;
    text-align: center;

    button {
      appearance: none;
      background: none;
      border: 0;
      outline: 0;

      &:focus, &:active {
        outline: 0;
      }
    }

    &::after {
      background: #333333;
      bottom: -1px;
      content: '';
      display: block;
      height: 2px;
      left: 0;
      position: absolute;
      -webkit-transition: all 0.3s ease-out;
      transition: all 0.3s ease-out;
      visibility: hidden;
      width: 100%;
    }

    &.is-active {
      &::after {
        visibility: visible;
      }
    }

    ~ .cycle-tabs-title {
      padding-top: 0;
    }
  }
}

li {
  display: inline-block;
  list-style-type: none;
}

@media (min-width: 768px) and (max-width: 1199px) {
  .cycle-tabs-title {
    + .cycle-tabs-title {
      margin: 0;
    }
  }
}

@media (max-width: 1199px) {
  .cycle-tabs-titles {
    display: flex;

    .cycle-tabs-title {
      flex: 1;

      &::after {
        bottom: -2px;
      }
    }
  }
}
</style>
